import { Component, inject } from '@angular/core';
import { LoadingBarService } from './loading-bar.service';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'app-loading-bar',
  template: '<div class="loading-bar"></div>',
  styleUrls: ['./loading-bar.component.scss'],
  host: { '[attr.data-component-id]': '"loading-bar"' }, // Уникальный атрибут для предотвращения дублирования
})
export class LoadingBarComponent {
  private loadingBar = inject(LoadingBarService);

  public navigationVisible$ = this.loadingBar.navigationVisible$;
  public navigationPercent$ = this.loadingBar.navigationPercent$;
  public fetchingVisible$ = this.loadingBar.fetchingVisible$;
  public fetchingPercent$ = this.loadingBar.fetchingPercent$;
}
